export default __webpack_public_path__ + "static/media/email_icon.38293327.svg";